import * as React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { Auth } from "@aws-amplify/auth";
import { useSessionStorage } from "usehooks-ts";
import { TradeCentricService } from "../../gen/clients/llts";
import { LoadingPage } from "../../components/LoadingPage/LoadingPage";
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import { COUPA_REQUEST_ID_SESSION_STORAGE_KEY } from "../../utils/constants";
import { useNavigation } from "../../hooks/useNavigation";
import { ROUTES } from "../../utils/navigationUtils";

interface PathParams {
  requestId: string;
}

const CoupaStarterPage: React.FC = () => {
  const { requestId } = useParams<PathParams>();
  const { navigateTo } = useNavigation();
  const [, storeRequestId] = useSessionStorage(COUPA_REQUEST_ID_SESSION_STORAGE_KEY, "");
  const [errorMessage, setErrorMessage] = React.useState<string>();

  const { data, error } = useQuery(["initializeLogIn", requestId], {
    queryFn: () => TradeCentricService.initializeLogIn({ requestBody: { requestId } })
  });

  React.useEffect(() => {
    storeRequestId(requestId || "");
  }, [requestId, storeRequestId]);

  React.useEffect(() => {
    if (!data) {
      return;
    }
    window.setTimeout(async () => {
      try {
        await Auth.signIn({ username: data.username, password: data.token });
        navigateTo(ROUTES.COUPA);
      } catch (e) {
        setErrorMessage("Unable to sign in.  Please try again later.");
      }
    }, 0);
  }, [data, navigateTo]);

  if (error || errorMessage) {
    return <ErrorPage apiError={error || errorMessage} />;
  }

  return <LoadingPage />;
};

export { CoupaStarterPage };
